import React, { useEffect, useState } from 'react';
import { CircularProgress } from '@material-ui/core';
import { useLocation } from 'react-router-dom';
import * as S from './styles';
import Card from './card';
import api from '../../../../../_core/api';
import { handleErrors } from '../../../../../_core/services/toast';
import { BillingInfo } from '../../types';

type Props = {
  customerPriorizationData: BillingInfo;
};

export type InadimplenciaItem = {
  monthYear: string;
  luc: string;
  totalInvoiced: number;
  rentsInvoiced: number;
  commercialsInvoiced: number;
  condominiumInvoiced: number;
  fundInvoiced: number;
  confessionInvoiced: number;
  totalDefaultMonth: number;
  shoppingDefaultPercentage: number;
  rentsDefault: number;
  commercialsDefault: number;
  condominiumDefault: number;
  fundDefault: number;
  confessionDefault: number;
};

const Inadimplencia: React.FC<Props> = ({ customerPriorizationData }) => {
  const location = useLocation();
  const queryParams = new URLSearchParams(location.search);
  const month = queryParams.get('month');
  const year = queryParams.get('year');

  const [loading, setLoading] = useState(false);
  const [inadItems, setInadItems] = useState<InadimplenciaItem[]>();

  useEffect(() => {
    getData();
  }, []);

  const getData = async () => {
    try {
      setLoading(true);
      const { data } = await api.get<InadimplenciaItem[]>(
        `/api/allos/v1/prioritization/default/client/${customerPriorizationData.clientId}/month/${month}/year/${year}/unidEcon/${customerPriorizationData.unitEcon}`,
      );
      setInadItems(data);
    } catch (e) {
      handleErrors(e);
    }
    setLoading(false);
  };

  return (
    <S.Wrapper>
      <S.CardContainer>
        {loading && (
          <S.LoadingWrapper>
            <CircularProgress />
          </S.LoadingWrapper>
        )}

        {!loading && inadItems?.map(i => <Card item={i} />)}
      </S.CardContainer>
    </S.Wrapper>
  );
};

export default Inadimplencia;
